import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lib-boolean-icon',
    templateUrl: './boolean-icon.component.html',
    styleUrls: ['./boolean-icon.component.scss'],
})
export class BooleanIconComponent implements OnInit {
    @Input() public value = true;

    constructor() {}

    ngOnInit(): void {}
}
